import { flow, groupBy, mapValues, sumBy } from 'lodash-es'

import { AdditionalPriceOption } from './types'

export const getAdditionalItemsTotals = flow(
  // Group by tag, sum premium, take absolute values
  (items: AdditionalPriceOption[]) => groupBy(items, (it) => it.tag),
  (grouped) => mapValues(grouped, (items) => Math.abs(sumBy(items, (it) => it.premium))),
)
